import { render, staticRenderFns } from "./HomeMainPartnerRules.vue?vue&type=template&id=7913e20a&scoped=true&"
import script from "./HomeMainPartnerRules.vue?vue&type=script&lang=js&"
export * from "./HomeMainPartnerRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7913e20a",
  null
  
)

export default component.exports